import requestAction from '../../utils/requestAction'

export const fetchOrderStatuses = (orderId: string, params: string) =>   
  requestAction('ORDER_STATUSES', params)(`orderstatuses/${orderId}`, 'GET')
